/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import ComponentBase from '../ComponentBase';
import CLog from '../ComponentLogger';
import InjectableComponent from './ComponentReference/InjectableComponent';
import KeyShortcutComponent from './KeyShortcutComponent';

/** @hidden */
// tslint:disable-next-line:typedef
const property = cc._decorator.property;

/**
 * Component that links a [[KeyShortcutComponent]] event to toggle active
 * property of a node.
 */
@cc._decorator.ccclass
export default class ShortcutToggleComponent extends ComponentBase
{
    /** [[KeyShortcutComponent]] to trigger event. */
    @property({ type: KeyShortcutComponent, visible: true })
    private _keyShortcutComponent: KeyShortcutComponent = null;

    @property(InjectableComponent)
    protected keyShortcutRef: InjectableComponent<KeyShortcutComponent>
        = new InjectableComponent<KeyShortcutComponent>();

    /** Should the initial value of the target nodes be active or not. */
    @property ({ visible: true })
    private _defaultActive: boolean = false;

    /** Nodes whose active property will be toggled. */
    @property({ type: [cc.Node], visible: true })
    private _targetNodes: cc.Node[] = [];

    /** @hidden */
    protected setContexts(): void
    {
        this.keyShortcutRef.SetContext(KeyShortcutComponent);
    }

    /** @hidden */
    public onLoad(): void
    {
        super.onLoad();

        if (this._targetNodes.length < 1)
        {
            this._targetNodes.push(this.node);
        }

        cc.systemEvent.dispatchEvent(new cc.Event.EventKeyboard(cc.SystemEvent.EventType.KEY_DOWN, true));

        cc.systemEvent.on(cc.SystemEvent.EventType.KEY_DOWN, this.onKeyDownHandler.bind(this), this);
    }

    /** @hidden */
    protected start(): void
    {
        super.start();

        if (!this._keyShortcutComponent) { this._keyShortcutComponent = this.keyShortcutRef.Value; }

        if (!this._keyShortcutComponent)
        {
            CLog.error("No key shortcut found.", this);
            this.enabled = false;
            return;
        }

        this.setActive(this._defaultActive);
    }

    /** @hidden */
    protected onDestroy(): void
    {
        if (cc.systemEvent)
        {
            cc.systemEvent.off(cc.SystemEvent.EventType.KEY_DOWN, this.onKeyDownHandler, this);
        }

        super.onDestroy();
    }

    /** Handler for [[KeyShortcutComponent]] key down event. */
    public onKeyDownHandler(event): void
    {
        if (!this._keyShortcutComponent || event.keyCode !== this._keyShortcutComponent.Key) { return; }

        this.setActive(!this._targetNodes[0].active);
    }

    /** Helper for setting all target nodes active property. */
    private setActive(to: boolean): void
    {
        this._targetNodes.forEach(node => node.active = to);
    }
}
